<template>
  <div class="app-view-ident-data">
    <slot name="txtBefore">Daten zur Identifikation</slot>
    <div class="ident-data" v-if="identData">
    <b-row class="nationality">
      <b-col md="" sm="12" class="label">
        <slot name="lblNationality">Staatsangehörigkeit:</slot>
      </b-col>
      <b-col md="" sm="12" class="value">{{identData.nationality.name}}</b-col>
    </b-row>
    <b-row class="ident-card">
      <b-col md="" sm="12" class="label">
        <slot name="lblIdentCard">Ausweistyp:</slot>
      </b-col>
      <b-col md="" sm="12" class="value">{{identData.identCard.name}}</b-col>
    </b-row>
    <b-row class="ident-type">
      <b-col md="" sm="12" class="label">
        <slot name="lblIdentType">Ident-Verfahren:</slot>
      </b-col>
      <b-col md="" sm="12" class="value">
        <slot :name="`txtIdentType${identData.identType}`">{{identData.identType}}</slot>
      </b-col>
    </b-row>
    </div>
  </div>
</template>
<script>

import { BCol, BRow } from 'bootstrap-vue'

export default {
  name: 'ShowIdentData',
  props: {
    identData: {
      type: Object
    }
  },
  components: { BRow, BCol }
}
</script>
